<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <ul class="placeul">
                    <li>商标注册</li>
                    <li>商标注册介绍</li>
                </ul>
            </ul>
        </div>
        <div class="mainindex">
            <img src="http://www.yanzhengma.cn/static/img/sbzc_01.jpg" style="width: 100%; display: block;"/>
            <a target="_blank" href="//wpa.b.qq.com/cgi/wpa.php?ln=1&key=XzgwMDAyMDIxNF80ODkyNjJfODAwMDIwMjE0XzJf"><img src="//www.2office.cn/static/img/sbzc_02.jpg" style="width: 100%; display: block;"/></a>
            <img src="http://www.yanzhengma.cn/static/img/sbzc_03.jpg" style="width: 100%; display: block;"/>
        </div>

        

    </div>
</template>

<script>
export default {
    
    data() {
        return {
            
        }
    },
    mounted() {
        
    },
    methods:{
        
    }
}
</script>


// WEBPACK FOOTER //
// src/components/brandreg.vue